import { WidgetOptions } from '@sprinklr/stories/widget/WidgetOptions';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { observable } from 'mobx';
import { DecimalFormat } from 'utils/Number/NumberUtils';
import { LabelTextFormat } from '@sprinklr/stories/widget/types';

export interface GoogleTrendsWidgetOptions extends WidgetOptions {
    height?: number;
    width?: number;
}

export class GoogleTrendsWidgetOptionsImpl extends WidgetOptionsImpl
    implements GoogleTrendsWidgetOptions {
    @observable labelSize = 20;

    @observable showMetricName = true;
    @observable metricNameSize = 10;

    @observable showMetricValue = true;
    @observable metricValueFormat: DecimalFormat = '1k';
    @observable metricValueSize = 25;

    @observable spacing = 1;
    @observable padding = 8;

    @observable labelTextFormat: LabelTextFormat = 'clamp';
    @observable labelLineClamp = true;
    @observable labelLineClampValue = 2;
    @observable labelWrapText = false;
    @observable textFitMin = 20;
    @observable textFitMax = 400;
}
